import {
  type ViewExtensionContext,
  ViewExtensionProvider,
} from '@blocksuite/affine-ext-loader';

import { effects } from './effects';
import { SlashMenuExtension } from './extensions';

export class SlashMenuViewExtension extends ViewExtensionProvider {
  override name = 'affine-slash-menu-widget';

  override effect() {
    super.effect();
    effects();
  }

  override setup(context: ViewExtensionContext) {
    super.setup(context);
    // Edgeless on mobile has no text-entry surface for the trigger key, but
    // mobile page does; it renders `affine-mobile-slash-menu` instead of the
    // caret-anchored popover.
    if (context.scope === 'mobile-edgeless') return;
    context.register(SlashMenuExtension);
  }
}
